import isMobile from "./is-mobile";


export default function showMoreDesc(){
    const showMoreEles = document.querySelectorAll('[data-type="showmore"]');
    showMoreEles.forEach((ele, index)=>{
        const linesProperty = '--_line-count';
        const maxHeightProperty = "--_max-Height";
        const stateAttr = 'data-state';
        const hasshowattr = "data-has-showmore"
        const v2Attr = "data-style-version-2";
        const isV2Ele = ele.hasAttribute(v2Attr);
        const increValue = isV2Ele ? 24 : 0;
        let showLinesCount = parseInt(window.getComputedStyle(ele).getPropertyValue(linesProperty));
        let lineHeight = parseInt(window.getComputedStyle(ele).lineHeight);
        let condition = ele.scrollHeight > (lineHeight * showLinesCount);
        ele.setAttribute(hasshowattr, `${condition}`);
        let actualHeight = `${ele.scrollHeight + increValue}px`;
        let overflowHeight = `${showLinesCount * lineHeight}px`;
        window.addEventListener('resize', ()=>{
            showLinesCount = parseInt(window.getComputedStyle(ele).getPropertyValue(linesProperty));
            lineHeight = parseInt(window.getComputedStyle(ele).lineHeight);
            condition = ele.scrollHeight > (lineHeight * showLinesCount);
            ele.setAttribute(hasshowattr, `${condition}`);
            actualHeight = `${ele.scrollHeight + increValue}px`;
            overflowHeight = `${showLinesCount * lineHeight}px`;
        })
        // console.log(ele.scrollHeight / lineHeight)
        if(condition){
            ele.addEventListener('click', ()=>{
                const IsStateShow = ele.getAttribute(stateAttr) === 'show';
                ele?.style.setProperty(maxHeightProperty, IsStateShow ? overflowHeight : actualHeight);
                ele.setAttribute(stateAttr, IsStateShow ? 'hide' : 'show');
            })
        }
        else{
            if(isMobile() && v2Attr){
                ele?.style.setProperty(maxHeightProperty, '100%');
                ele.setAttribute(stateAttr, 'hide');
            }    
        }
    })
}